import first from "lodash/first";
import last from "lodash/last";
import { Children, ComponentProps, isValidElement, useMemo } from "react";
import CardMedia from "@/CardMedia";

import Paper from "@/Paper";
import { cardClasses, type CardVariants } from "./Card.style";
import { CardContext, CardContextTypes } from "./CardContext";
import { CardMediaProps } from "@/CardMedia/useCardMedia";

export type CardProps = ComponentProps<typeof Paper> & CardVariants;

const Card = (props: CardProps) => {
  const { outlined, ...rest } = props;

  const isCardMedia = (
    child: React.ReactNode
  ): child is React.ReactElement<CardMediaProps> => {
    return isValidElement(child) && child.type === CardMedia;
  };

  const initialValue = useMemo((): CardContextTypes => {
    const cardChildren = Children.toArray(props.children);

    return {
      mediaPosition: isCardMedia(first(cardChildren))
        ? "top"
        : isCardMedia(last(cardChildren))
          ? "bottom"
          : "middle",
      contentPosition: "middle",
      actionPosition: "bottom",
      headerPosition: "top",
    };
  }, [props.children]);
  return (
    <CardContext.Provider value={initialValue}>
      <Paper
        ref={props.ref}
        variant={outlined ? "outlined" : "elevation"}
        className={cardClasses({ outlined })}
        {...rest}
      />
    </CardContext.Provider>
  );
};

Card.displayName = "Card";

export default Card;
